<template>
  <div>
    <SimpleHeader />
    <HeaderAdvertiser v-if="showHeaderAdvertiser && !isMobile()" />
    <router-view />
  </div>
</template>

<script>
import { mapActions } from 'vuex';

import SimpleHeader from '@/components/SimpleHeader';
import HeaderAdvertiser from '@/components/HeaderAdvertiser'
import PlatformsMixins from '@/mixins/PlatformsMixins';

export default {
  name: "App",
  mixins: [PlatformsMixins],
  components: {
    SimpleHeader,
    HeaderAdvertiser
  },
  computed: {
    showHeaderAdvertiser() {
      return Boolean(this.$route.params.name);
  }
  },
  methods: {
    ...mapActions("globalFlagsCompany", [
      "getGlobalFlagsCompany"
    ]),
    ...mapActions("participantFlags", [
      "getParticipantFlags"
    ]),
    configureScreen() {
      document.querySelector("html").style["overflow"] = "hidden";
    },
  },
  mounted() {
    this.getGlobalFlagsCompany();
    this.configureScreen();
  },
};
</script>
